module.exports = __webpack_public_path__ + "img/emoji_46.ca9e7774.png";